import React, { useState } from "react";
import { Card, CardContent, Typography, Box, Button, Tooltip } from "@mui/material";

function ResultsTable(props) {
    const { results, variables } = props;
    const [showStandards, setShowStandards] = useState(false);

    const outdoorResults = results.outdoorResults?.[0];

    var eavColor = "";

    if (variables.eavLessThan) {
        if (variables.eavGreaterThan) {
            eavColor = outdoorResults?.eav <= variables.eavLessThan && outdoorResults?.eav >= variables.eavGreaterThan ? "#4CAF50" : "red";
        }
        else {
            eavColor = outdoorResults?.eav <= variables.eavLessThan ? "#4CAF50" : "red";
        }
    }
    else if (variables.eavGreaterThan) {
        eavColor = outdoorResults?.eav >= variables.eavGreaterThan ? "#4CAF50" : "red";
    }


    const eminColor = variables.eMinGreaterThan
        ? outdoorResults?.emin >= variables.eMinGreaterThan ? "#4CAF50" : "red"
        : "";

    const emaxColor = variables.eMaxLessThan
        ? outdoorResults?.emax <= variables.eMaxLessThan ? "#4CAF50" : "red"
        : "";

    const renderStandards = () => {
        let standardsList = [];

        if (variables.eavGreaterThan) standardsList.push(`Eav > ${variables.eavGreaterThan}`);
        if (variables.eavLessThan) standardsList.push(`Eav < ${variables.eavLessThan}`);
        if (variables.eMinGreaterThan) standardsList.push(`Emin ≥ ${variables.eMinGreaterThan}`);
        if (variables.eMaxLessThan) standardsList.push(`Emax ≤ ${variables.eMaxLessThan}`);
        if (variables.lavGreaterThan) standardsList.push(`Lav > ${variables.lavGreaterThan}`);
        if (variables.reiGreaterThan) standardsList.push(`Rei > ${variables.reiGreaterThan}`);
        if (variables.tiLessThan) standardsList.push(`TI < ${variables.tiLessThan}`);
        if (variables.u0GreaterThan) standardsList.push(`U0 ≥ ${variables.u0GreaterThan}`);
        if (variables.ulGreaterThan) standardsList.push(`UL ≥ ${variables.ulGreaterThan}`);
        if (variables.wetU0GreaterThan) standardsList.push(`Wet U0 ≥ ${variables.wetU0GreaterThan}`);

        return standardsList.map((standard, index) => (
            <Typography variant="body2" key={index}>
                {standard}
            </Typography>
        ));
    };

    return (
        <Card sx={{ marginBottom: 2, padding: 2, boxShadow: 3 }}>
            <CardContent>
                <Typography variant="h6" gutterBottom sx={{ whiteSpace: 'nowrap' }}>
                    Results for {props.name && props.name.length > 17
                        ? `${props.name.slice(0, 14)}...`
                        : props.name}:
                </Typography>



                <Box>
                    <Typography variant="body1" gutterBottom>
                        <strong>Valid:</strong>{" "}
                        <span style={{ color: results.valid === "False" ? "red" : "#4CAF50" }}>
                            {results.valid}
                        </span>
                    </Typography>
                    <Tooltip title={renderStandards()} placement="top">
                        <Typography variant="body1" gutterBottom>
                            <strong>Target Class:</strong> {props.standard.split(' ')[0] + " : " + results.targetClass}
                        </Typography>
                    </Tooltip>
                    <Typography variant="body1" gutterBottom>
                        <strong>Eav:</strong>{" "}
                        <span style={{ color: eavColor }}>
                            {outdoorResults?.eav ?? "N/A"}
                        </span>
                    </Typography>
                    <Typography variant="body1" gutterBottom>
                        <strong>Emin:</strong>{" "}
                        <span style={{ color: eminColor }}>
                            {outdoorResults?.emin ?? "N/A"}
                        </span>
                    </Typography>
                    <Typography variant="body1" gutterBottom>
                        <strong>Emax:</strong>{" "}
                        <span style={{ color: emaxColor }}>
                            {outdoorResults?.emax ?? "N/A"}
                        </span>
                    </Typography>
                    <Typography variant="body1" gutterBottom>
                        <strong>Emin/Emax:</strong>{" "}
                        <span>
                            {(outdoorResults?.emin / outdoorResults?.emax).toFixed(2) ?? "N/A"}
                        </span>
                    </Typography>
                    <Typography variant="body1" gutterBottom>
                        <strong>Emin/Eav:</strong>{" "}
                        <span>
                            {(outdoorResults?.emin / outdoorResults?.eav).toFixed(2) ?? "N/A"}
                        </span>
                    </Typography>

                    {/* <Button
                        variant="outlined"
                        color="primary"
                        onClick={() => setShowStandards(prevState => !prevState)}
                        sx={{
                            marginTop: 2,
                            fontSize: '0.8rem',
                            padding: '4px 8px',
                            height: '30px',
                        }}
                    >
                        {showStandards ? "Hide Standards" : "Show Standards"}
                    </Button>

                    {showStandards && (
                        <Box sx={{ marginTop: 2 }}>
                            <Typography variant="h6" gutterBottom>
                                Standards:
                            </Typography>
                            {renderStandards()}
                        </Box>
                    )} */}
                </Box>
            </CardContent>
        </Card>
    );
}

export default ResultsTable;
